// extracted by mini-css-extract-plugin
module.exports = {"container":"SidebarLoading_container__DxmsN","header":"SidebarLoading_header__ADs3q","subtitle":"SidebarLoading_subtitle__MLNcw"};